<template>
  <TabWrapper :pills="blok.pills" :icon-tabs="blok.icon_tabs">
    <TabItem
      v-for="(childBlok, index) in blok.tabs"
      :key="childBlok._uid"
      v-editable="blok"
      :title="childBlok.title"
      :icon="childBlok.icon"
      :icon-active="childBlok.icon_active"
      :tab-index="index"
      :pills="blok.pills"
      :icon-tabs="blok.icon_tabs"
    >
      <StoryblokComponent
        v-for="content in childBlok.content"
        :key="content._uid"
        v-editable="blok"
        :blok="content"
      />
    </TabItem>
  </TabWrapper>
</template>

<script lang="ts" setup>
import type { SbTabWrapper } from '@/types'
interface Props {
  blok: SbTabWrapper
}
defineProps<Props>()
</script>
